<script> 
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import forminput from "../formcomponet/forminput.vue"; 
import satdosyazarfteslim from "@/models/satdosyazarfteslim";
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  mixins: [apibtoast, apigeneric, satdosyazarfteslim],
  props: ["Id", "AddEdit", "satdosyaId"],
  data() {
    return {
      FormData: {},
    };
  },
  components: {
    Loader, 
    Treeselect,
    forminput

 
  },
  watch: {
    Id() {
      this.FormData = this.Id;
      this.FormData.Dosyaid = this.satdosyaId;
    },
  },
  methods: {
    onSubmit() {
       this.FormData.Dosyaid = this.satdosyaId;
      this.$v.$touch();
        
      if (!this.$v.$invalid) {  
     
        if (this.AddEdit == "Add") {
          this.Post("SatDosyaZarfTeslim", this.FormData).then((res) => {
            if (res) { 
              let satdosyafirmaData= {
        Dosyaid: this.FormData.Dosyaid,
        Firmaid: this.FormData.Firmaid,
        Degerlendirmeid: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        Kararid: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        Firmaturu: 3, 
      }
      this.Post("satdosyafirma", satdosyafirmaData, false)
                this.$emit("TableUpdate");
                 this.$bvModal.hide("satdosyazarfteslim"); 
            }
          });
        } else {
          this.Update("SatDosyaZarfTeslim", this.FormData).then((res) => {
            if (res) {
              
              this.$emit("TableUpdate");
              this.$bvModal.hide("satdosyazarfteslim");

            }
          });
        }
      }
    },
    Get() {


    }, 
     
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="satdosyazarfteslim"
      size="lg"
      :title="
        this.AddEdit == 'Edit'
          ? $t('satdosyazarfteslim.AddEdit.FormTitleEdit')
          : $t('satdosyazarfteslim.AddEdit.FormTitleAdd')
      "
      title-class="font-18"
      hide-footer
    >  
  
      <Form @submit.prevent="onSubmit">  

            <forminput
              style="width:100px"
                :FormDataType="FormDataType.Sirano"
                :Value="FormData.Sirano"
                :v="$v.FormData.Sirano"
                @input="FormData.Sirano = $event"
              />
     


            <b-form-group class="mb-3" id="example text"  :label="FormDataType.Firmaid.FieldTitle" label-for="text">
              <treeselect
              :multiple="false"
              :options="FormDataType.Firmaid.ComboDataArray"
              :placeholder="$t('OrtakKullanim.seciniz')"
              v-model="FormData.Firmaid" 
                :class="{ 'is-invalid': $v.FormData.Firmaid.$error }"
              />
              <treeselect-value :value="FormData.Firmaid" />
                
                  <div v-if="$v.FormData.Firmaid.$error" class="invalid-feedback"> 
              <span v-if="$v.FormData.Firmaid.required == false">{{  $t("ValidationMessage.required") }}</span> 
            </div>
            </b-form-group>

             <b-form-group class="mb-3" id="example text"  :label="FormDataType.Teslimtarihsaat.FieldTitle" label-for="text">

            <input id="date-time" 
             style="width:300px"
            type="datetime-local" 
            class="form-control"
            :FormDataType="FormDataType.Teslimtarihsaat"
               v-model="FormData.Teslimtarihsaat"
              :v="$v.FormData.Teslimtarihsaat"
            >
             </b-form-group>

              <b-form-group class="mb-3" id="example text"  :label="FormDataType.Personelid.FieldTitle" label-for="text">
              <treeselect
              :multiple="false"
              :options="FormDataType.Personelid.ComboDataArray"
              :placeholder="$t('OrtakKullanim.seciniz')"
              v-model="FormData.Personelid" 
                :class="{ 'is-invalid': $v.FormData.Personelid.$error }"
              />
              <treeselect-value :value="FormData.Personelid" />
                
                  <div v-if="$v.FormData.Personelid.$error" class="invalid-feedback"> 
              <span v-if="$v.FormData.Personelid.required == false">{{  $t("ValidationMessage.required") }}</span> 
            </div>
            </b-form-group>


 
        <button class="btn btn-primary" type="submit">
          {{ $t("satdosyazarfteslim.AddEdit.Button") }}
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
